import React, { FC } from 'react';
import styles from 'components/ExternalIntegration/AddModule.module.scss';
import TableRow from 'components/Table/TableRow';
import SkeletonRectangle from 'components/Skeleton/SkeletonRectangle';
import TableBodyCell from 'components/Table/TableBodyCell';
import TableActionCell from 'components/Table/TableActionCell';

const SkeletonIntegrationLine: FC = () => {
  return (
    <TableRow disableHover className={styles.skeletonRow}>
      <TableBodyCell className={styles.dataItemSkeleton}>
        <SkeletonRectangle width="80%" height="16px" color="primary6" />
      </TableBodyCell>
      <TableBodyCell className={styles.variableSkeleton}>
        <SkeletonRectangle width="80%" height="16px" color="primary6" />
      </TableBodyCell>
      <TableActionCell />
    </TableRow>
  );
};

export default SkeletonIntegrationLine;
